import { spaceApi } from '@/api/space.api';
import { useQuery, useMutation, useQueryClient } from '@tanstack/vue-query';
import { storeToRefs } from 'pinia';

export function useSpaces() {
  const queryClient = useQueryClient();
  const appStore = storeToRefs(useAppStore());
  return useQuery({
    queryKey: ['spaces', appStore.currentOrganisationId],
    queryFn: async () => {
      const spaces = await spaceApi.getAll(toValue(appStore.currentOrganisationId), toValue(appStore.onboardingIsLive));
      spaces.forEach((s) => {
        queryClient.setQueryData(['spaces', appStore.currentOrganisationId, s.workspace_id], s);
      })
      return spaces;
    },
    enabled: !!toValue(appStore.currentOrganisationId),
  });
}

export function useSpace() {
  const appStore = storeToRefs(useAppStore());
  return useQuery({
    queryKey: ['spaces', appStore.currentOrganisationId, appStore.currentSpaceId],
    queryFn: () => spaceApi.get(toValue(appStore.currentOrganisationId), toValue(appStore.currentSpaceId), toValue(appStore.onboardingIsLive)),
    enabled: !!toValue(appStore.currentOrganisationId) && !!toValue(appStore.currentSpaceId)
  });
}

export function useCreateSpace() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (space: { organisationId: string, name: string, imageId: string }) => spaceApi.create(space.organisationId, space.name, space.imageId),
    onSuccess: (space) => {
      queryClient.invalidateQueries({ queryKey: ['spaces', space.company_id] });
    }
  });
}

export function useEditSpace() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (space: { organisationId: string, spaceId: string, name: string, imageId: string }) => spaceApi.update(space.organisationId, space.spaceId, space.name, space.imageId),
    onSuccess: (space) => {
      queryClient.invalidateQueries({ queryKey: ['spaces', space.company_id] });
    }
  });
}